export const CATEGORY_FILTER_NAME = 'group_id'
export const FILTER_KEYS_PARAM = 'filterKeys'
export const FILTER_DESIGN_FLAGS = {
  allExpanded: 1,
  allCollapsed: 2,
  firstFewExpanded: 3
}
export const COLLECTION_VARIANTS = {
  ids: 'ids',
  collectionId: 'collectionId'
}

export const LOCALE_NL = 'nl'
export const LOCALE_FR = 'fr'
export const LOCALE_BE = 'be'
export const LOCALE_NL_NL = 'nl_NL'
export const LOCALE_NL_BE = 'nl_BE'
export const LOCALE_FR_BE = 'fr_BE'
export const LOCALE_FR_FR = 'fr_FR'

export const LOCALES = {
  [LOCALE_NL]: 'nl-NL',
  [LOCALE_FR]: 'fr-BE',
  [LOCALE_NL_NL]: 'nl-NL',
  [LOCALE_NL_BE]: 'nl-BE',
  [LOCALE_FR_BE]: 'fr-BE',
  [LOCALE_FR_FR]: 'fr-BE'
}

export const LABELS_MAP_BRICO = {
  'Livraison à domicile': 'Livraison',
  'Disponible en magasin': 'En magasin',
  Thuisbezorgd: 'Beschikbaar voor leveringen',
  'Beschikbaar in winkel': 'Beschrikbaar via de winkel'
}
export const AVAILABILITY_FILTER_NAMES = ['Aankoopmogelijkheden', 'Bezorg- en ophaalopties', 'Possibilités d’achat']
